"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Menu = void 0;

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _MenuItem = _interopRequireDefault(require("../MenuItem"));

var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _ListItemIcon = _interopRequireDefault(require("../ListItemIcon"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Menu = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Menu, _Component);

  var _super = _createSuper(Menu);

  function Menu(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Menu);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });

      if (_this.props.stopPropagation) {
        event.stopPropagation();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClose", function (event) {
      _this.setState({
        anchorEl: null
      });

      if (_this.props.stopPropagation) {
        event.stopPropagation();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEvent", function (event, action) {
      action(event);

      if (_this.props.closeOnClick) {
        _this.handleClose(event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMenuButton", function () {
      var _this$props = _this.props,
          headerText = _this$props.headerText,
          icon = _this$props.icon,
          type = _this$props.type;

      if (icon) {
        return {
          content: icon,
          type: "icon"
        };
      } else if (type === "action") {
        return {
          content: /*#__PURE__*/_react.default.createElement(_MoreVert.default, null),
          type: "icon",
          title: "Actions"
        };
      } else {
        return {
          content: headerText,
          type: "default"
        };
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAnchorOrigin", function () {
      var _this$props2 = _this.props,
          anchorOrigin = _this$props2.anchorOrigin,
          type = _this$props2.type; // If anchorOrigin passed as a prop use it

      if (typeof anchorOrigin !== "undefined") {
        return anchorOrigin;
      } else {
        switch (type) {
          // If no type prop provided
          case "default":
            return {
              vertical: "bottom",
              horizontal: "center"
            };
          // "None" type will revert to Material UI default

          case "none":
            return undefined;
          // All others

          default:
            return {
              vertical: "bottom",
              horizontal: "right"
            };
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getTransformOrigin", function () {
      var _this$props3 = _this.props,
          transformOrigin = _this$props3.transformOrigin,
          type = _this$props3.type; // If transformOrigin passed as a prop use it

      if (typeof transformOrigin !== "undefined") {
        return transformOrigin;
      } else {
        switch (type) {
          // If no type prop provided
          case "default":
            return {
              vertical: "top",
              horizontal: "center"
            };
          // "None" type will revert to Material UI default

          case "none":
            return undefined;
          // All others

          default:
            return {
              vertical: "top",
              horizontal: "right"
            };
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAnchorFunction", function () {
      var _this$props4 = _this.props,
          type = _this$props4.type,
          transformOrigin = _this$props4.transformOrigin,
          anchorOrigin = _this$props4.anchorOrigin;

      if (!anchorOrigin && !transformOrigin || type === "none") {
        return undefined;
      } else {
        return null;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props5 = _this.props,
          color = _this$props5.color,
          id = _this$props5.id,
          items = _this$props5.items,
          variant = _this$props5.variant,
          size = _this$props5.size,
          className = _this$props5.className,
          classes = _this$props5.classes,
          title = _this$props5.title,
          onMouseDown = _this$props5.onMouseDown,
          disableScrollLock = _this$props5.disableScrollLock,
          TransitionProps = _this$props5.TransitionProps,
          keepMounted = _this$props5.keepMounted;
      var anchorEl = _this.state.anchorEl;

      var renderedButton = /*#__PURE__*/_react.default.createElement(_Button.default, {
        id: id,
        className: (0, _classnames.default)("prmbl-menu-button", className, classes.button, {
          "prmbl-menu-button--menu-is-open": anchorEl != null
        }),
        color: color,
        size: size,
        variant: variant,
        "aria-owns": anchorEl ? "simple-menu" : null,
        "aria-haspopup": "true",
        onClick: _this.handleClick,
        type: _this.menuButtonProps.type,
        title: title ? title : _this.menuButtonProps.title ? _this.menuButtonProps.title : undefined,
        onMouseDown: onMouseDown
      }, _this.menuButtonProps.content);

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderedButton, /*#__PURE__*/_react.default.createElement(_Menu.default, {
        id: "".concat(id, "-menu"),
        className: (0, _classnames.default)("prmbl-menu", className, classes.menu),
        classes: {
          paper: classes.paper
        },
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: _this.handleClose,
        anchorOrigin: _this.anchorOrigin,
        transformOrigin: _this.transformOrigin,
        getContentAnchorEl: _this.anchorFunction,
        MenuListProps: {
          disablePadding: true
        },
        disableRestoreFocus: true,
        disableScrollLock: disableScrollLock,
        TransitionProps: TransitionProps,
        keepMounted: keepMounted
      }, items.map(function (item, index) {
        var key = "".concat(id, "-menuitem-").concat(index);
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          className: (0, _classnames.default)("prmbl-menu-item", className, classes.item),
          id: key,
          key: key,
          onClick: function onClick(event) {
            return _this.handleEvent(event, item.action);
          },
          selected: item.selected
        }, item.icon && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, {
          className: classes.icon
        }, item.icon), item.display);
      })));
    });
    _this.state = {
      anchorEl: null
    };
    _this.menuButtonProps = _this.getMenuButton();
    _this.anchorOrigin = _this.getAnchorOrigin();
    _this.transformOrigin = _this.getTransformOrigin();
    _this.anchorFunction = _this.getAnchorFunction();
    return _this;
  }

  return (0, _createClass2.default)(Menu);
}(_react.Component);

exports.Menu = Menu;
(0, _defineProperty2.default)(Menu, "propTypes", {
  /**
   * This is the point on the button where the popover will attach to. This is used to override how the menu opens.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(["left", "center", "right"])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(["top", "center", "bottom"])]).isRequired
  }),

  /**
   * This is the point on the popover which will attach to the button's origin. This is used to override how the menu opens.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(["left", "center", "right"])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(["top", "center", "bottom"])]).isRequired
  }),

  /**
   * The html id.
   */
  id: _propTypes.default.string,

  /**
   * The size of the component.
   */
  size: _propTypes.default.oneOf(["small", "medium", "large"]),

  /**
   * The variant type.
   */
  variant: _propTypes.default.oneOf(["text", "contained", "outlined"]),

  /**
   * The color type.
   */
  color: _propTypes.default.oneOf(["default", "primary", "secondary"]),

  /**
   * The header text for the menu.
   */
  headerText: _propTypes.default.string,

  /**
   * If set, will render the supplied icon instead of headerText
   */
  icon: _propTypes.default.node,

  /**
   * A collection of item for the menu.
   */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * The display value.
     */
    display: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]).isRequired,

    /**
     * The action triggered when clicked.
     */
    action: _propTypes.default.func.isRequired,

    /**
     * The icon element.
     */
    icon: _propTypes.default.node
  })).isRequired,

  /**
   * If true, we will stop propagation of event execution.
   */
  stopPropagation: _propTypes.default.bool,

  /**
   * Type of menu. This will determine where on the button the menu will pop out, unless the anchorOrigin or transformOrigin props are used.
   */
  type: _propTypes.default.oneOf(["default", "action", "topbar", "none"]).isRequired,

  /**
   * Classes to apply to the root
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   *
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes.default.node,

  /**
   * An accessibility label to display for the button. Defaults to the title prop. If title prop omitted, and the icon is a button variant, this is required for accessibility.
   */
  "aria-label": _propTypes.default.string,

  /**
   * Callback to execute when a user presses a mouse button over this element
   */
  onMouseDown: _propTypes.default.func,

  /**
   * Allow the page to scroll while the menu is open
   */
  disableScrollLock: _propTypes.default.bool,

  /**
   * Automatically close the Menu when the menu item is clicked
   */
  closeOnClick: _propTypes.default.bool,

  /**
   * Props to pass to the Transition
   */
  TransitionProps: _propTypes.default.object,

  /**
   * If true, the menu contents will stay mounted when the menu is closed
   */
  keepMounted: _propTypes.default.bool
});
(0, _defineProperty2.default)(Menu, "defaultProps", {
  variant: "text",
  color: "default",
  size: "medium",
  type: "default",
  closeOnClick: true
});

var _default = (0, _styles2.withStyles)(_styles.styles)(Menu);

exports.default = _default;